import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getauditLoadData from '../../services/dossier/get/getauditLoadData'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchAuditLoadData () {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const auditLoadData = yield call(getauditLoadData, auth.token)
    yield put(fetchCombosSuccess({ auditLoadData }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchauditLoadData () {
  yield takeLatest(combosActionTypes.FETCH_AUDIT_LOAD_DATA, fetchAuditLoadData)
}
